export default __webpack_public_path__ + "static/media/Traditional.605d7540.jpg";